var ContextBubbleAnimation;
(function (ContextBubbleAnimation) {
    ContextBubbleAnimation["FADE_IN"] = "FADE_IN";
    ContextBubbleAnimation["FADE_IN_OUT"] = "FADE_IN_OUT";
    ContextBubbleAnimation["FADE_IN_OUT_SHORT"] = "FADE_IN_OUT_SHORT";
})(ContextBubbleAnimation || (ContextBubbleAnimation = {}));
var ContextBubbleBackground;
(function (ContextBubbleBackground) {
    ContextBubbleBackground["DANGER"] = "DANGER";
    ContextBubbleBackground["DEFAULT"] = "DEFAULT";
    // This is a special one-off color for ENCON. They've requested the emergency hours bubble to be red, while we will
    // keep it the default for all other clients.
    ContextBubbleBackground["EMERGENCY_HOURS"] = "EMERGENCY_HOURS";
    ContextBubbleBackground["INVERT"] = "INVERT";
})(ContextBubbleBackground || (ContextBubbleBackground = {}));

export { ContextBubbleBackground as C, ContextBubbleAnimation as a };
